export default __webpack_public_path__ + "static/media/bnb-mist-closed-logo.3bdcf371.png";